import Cookies from "js-cookie";
import { toast } from "react-hot-toast";

let expiring = false;

/**
 * The server rejected our token (expired / revoked): forget the session so the header stops showing the
 * profile, tell the user and send them to the login page (remembering where they were).
 */
export function expireSession() {
  if (expiring || !Cookies.get("iran_token")) return;
  expiring = true;
  Cookies.remove("iran_token");
  Cookies.remove("iran_token", { path: "/" });
  try {
    ["mobile", "email"].forEach((k) => localStorage.removeItem(k));
    localStorage.setItem("redirectUrl", window.location.pathname + window.location.search);
  } catch (e) {
    /* storage unavailable */
  }
  toast.error("نشست شما منقضی شده است، لطفا دوباره وارد شوید");
  setTimeout(() => {
    window.location.replace("/login");
  }, 1200);
}

const isHttps = () => typeof window !== "undefined" && window.location.protocol === "https:";

/** Stores the login token: Secure on https, SameSite=Lax (not sent on cross-site sub-requests). */
export function setAuthToken(token, days) {
  const options = { sameSite: "lax", secure: isHttps(), path: "/" };
  if (days) options.expires = days;
  Cookies.set("iran_token", token, options);
}

/** Only same-site absolute paths may be used as a post-login destination ("/x", never "//evil.com" or "https://..."). */
export function safeRedirect(target, fallback = "/") {
  if (typeof target !== "string") return fallback;
  if (!target.startsWith("/") || target.startsWith("//") || target.startsWith("/\\")) return fallback;
  return target;
}
